class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button:not(.button-show-more)") || this.querySelector("span.collapsible-content--button");
    this.content = this.button.nextElementSibling;
    this.toggleButtons = this.querySelectorAll("button[data-collapsible='toggle']");
    this.scrollToTop = this.dataset.scrollToTop === "true";
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.button.addEventListener("click", this.toggle.bind(this));
    if (this.toggleButtons.length > 0) {
      this.toggleButtons.forEach((toggleButton) => {
        toggleButton.addEventListener("click", this.toggle.bind(this));
      });
    }
  }

  toggle() {
    const ariaExpanded = this.button.getAttribute("aria-expanded");
    if (ariaExpanded === "true") {
      this.button.setAttribute("aria-expanded", "false");
      this.content.setAttribute("aria-hidden", "true");
      if(!this.classList.contains('package-deal-accordion')) {
        this.scrollToAccordion();
      }
    } else {
      this.button.setAttribute("aria-expanded", "true");
      this.content.setAttribute("aria-hidden", "false");
      if(!this.classList.contains('package-deal-accordion')) {
        this.scrollToAccordion();
      }
    }
  }

  scrollToAccordion() {
    if (this.scrollToTop && window.innerWidth >= 990) {
      setTimeout(() => {
        window.scrollTo({
          top: this.getBoundingClientRect().top + window.scrollY - 300,
          behavior: "smooth",
        });
      }, 400);
    }
  }
}

customElements.define("collapsible-content", CollapsibleContent);
